import * as React from 'react';
import { FieldProps } from 'react-jsonschema-form-bs4';
import { TimePicker, TimePickerChangeEvent } from '@progress/kendo-react-dateinputs';
import * as moment from 'moment';

export default class TimeInput extends React.Component<FieldProps, any> {

    constructor(props: FieldProps) {
        super(props);
        this.state = { ...props.formData };
    }

    onChange(name: string) {
        return (event: TimePickerChangeEvent) => {
            this.setState({ [name]: typeof event.value === "string" ? event.value : event.value.toISOString() });
            setImmediate(() => this.props.onChange(this.state[name]));
        };
    }

    public render() {
        let value = this.state[this.props.name];

        if (typeof value === "string") {
            value = moment.utc(value).toDate();
        }

        return <React.Fragment>
            <div className="input-group">
                <div className="input-group-prepend">
                    <span className="input-group-text">{this.props.schema.title || "Time"}{this.props.required && <span style={{ color: '#dc3545' }}>*</span>}</span>
                </div>
                <TimePicker
                    format="hh:mm a"
                    formatPlaceholder="formatPattern"
                    className="form-control"
                    value={value}
                    onChange={this.onChange(this.props.name)}
                />
            </div>
        </React.Fragment>;
    }
}
